import React from "react"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import TitleBar from "../../components/TitleBar/TitleBar"
import {Webhooks, WebhooksColumns} from "../../components/Webhooks/Webhooks"
import {useIsUnitUser, useIsManagedSolutionsBankingUser} from "../../services/auth"
import {Events, EventsColumns} from "../../components/Webhooks/Events"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {useModal} from "react-modal-hook"
import NewWebhookModal from "../../components/Webhooks/NewWebhookModal"
import Icon from "../../components/Icon/Icon"
import classNames from "classnames"
import {useQueryState} from "use-location-state"
import {OrgBankingSetupProvider, useOrgBankingSetup} from "../../services/orgBankingSetup"
import {hasPermission} from "../../services/permission"

type WebhooksTabs = "Subscriptions" | "Events"

export default function WebhooksPage() {
	const [showModal, hideModal] = useModal(() => (
		<OrgBankingSetupProvider>
			<NewWebhookModal close={hideModal} refresh={refresh} />
		</OrgBankingSetupProvider>
	))
	const [refreshToken, refresh] = useRefreshToken()
	const [currentTab, setCurrentTab] = useQueryState<WebhooksTabs>("tab", "Subscriptions")
	const {setup} = useOrgBankingSetup()
	const isManagedSolutionsBankingUser = useIsManagedSolutionsBankingUser()
	const isManagedSolutionsBuildPath = setup === "ReadyToLaunchBanking" || isManagedSolutionsBankingUser

	return (
		<>
			<TitleBar title={"Webhooks"} className={"title-bar-no-border"}>
				{currentTab === "Subscriptions" && (
					<button className="button button-create" onClick={() => showModal()}>
						<Icon icon="interface-add-1" size={12} /> Create
					</button>
				)}
			</TitleBar>

			<nav className="webhooks-tabs tabs-container">
				<div className="tabs">
					<ul>
						<li
							className={classNames(currentTab == "Subscriptions" && "is-active")}
							onClick={() => setCurrentTab("Subscriptions")}
						>
							<a>Subscriptions</a>
						</li>
						{(!useIsUnitUser() && hasPermission("event", "get")) || hasPermission("rtl.event", "get") ? (
							<li className={classNames(currentTab == "Events" && "is-active")} onClick={() => setCurrentTab("Events")}>
								<a>Events</a>
							</li>
						) : null}
					</ul>
				</div>
			</nav>

			<MainSectionTable>
				{currentTab === "Subscriptions" && (
					<Webhooks
						refreshToken={refreshToken}
						includedColumns={[
							WebhooksColumns.id,
							...(useIsUnitUser() ? [WebhooksColumns.org] : []),
							WebhooksColumns.label,
							WebhooksColumns.url,
							WebhooksColumns.status,
							WebhooksColumns.contentType,
							WebhooksColumns.subscriptionType,
							WebhooksColumns.delivery,
							WebhooksColumns.createdAt,
							WebhooksColumns.toggle,
						]}
					/>
				)}
				{currentTab === "Events" && (
					<Events
						refreshToken={refreshToken}
						includedColumns={[EventsColumns.id, EventsColumns.type, EventsColumns.createdAt]}
						useRtlEndpoint={hasPermission("rtl.event", "get") || isManagedSolutionsBuildPath}
					/>
				)}
			</MainSectionTable>
		</>
	)
}
